<script setup lang="ts">
import { isDateAfter, today } from '@/utils/temporalUtils';
import { computed } from 'vue';
import type { ResolvedSelfSellInModel } from '../../composables/useSelfSellIn';
import SectionContainer from '../SectionContainer.vue';
import SectionHeader from '../SectionHeader.vue';
import ImportantDatesCard from './ImportantDatesCard.vue';

type ImportantDateEvent = NonNullable<ResolvedSelfSellInModel['importantDatesSection']>['events'][number];

const props = defineProps<{ data: NonNullable<ResolvedSelfSellInModel['importantDatesSection']> }>();

const filteredDates = computed(() =>
  props.data.events.filter((event: ImportantDateEvent) => isDateAfter(event.date, today())),
);
</script>

<template>
  <SectionContainer :section-title="data.title">
    <SectionHeader :title="data.title" :description="data.description" />
    <div class="important-dates-cards">
      <template v-for="event in filteredDates" :key="event.date">
        <ImportantDatesCard :data="event" />
      </template>
    </div>
  </SectionContainer>
</template>

<style lang="scss" scoped>
.important-dates-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(265px, 100%), 1fr));
  gap: 4px;
}
</style>
